import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import { fetchValuelists, initialState } from '../services/fetchValuelists'

export { useValuelists }

const queryKey = 'valuelists'

const useValuelists = () => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data } = useQuery({
    queryFn: fetchValuelists,
    queryKey: [queryKey],
    enabled: hasPermissions,
  })

  return {
    data: data || initialState.data,
  }
}
